// extracted by mini-css-extract-plugin
export var container = "_6t-0";
export var fallback = "_6t-5";
export var fallbackIcon = "_6t-6";
export var hidden = "_6t-2";
export var image = "_6t-3";
export var loaded = "_6t-4";
export var placeholder = "_6t-1";